
import LoadingMask from "@/components/LoadingMask.vue";
import FileUploadProgress from "@/components/FileUploadProgress.vue";
// import watermark from "@/components/watermark.vue";
import GlobalLoadingService from "@/utils/globalLoading";
import LoginService from "@/utils/loginService";
import moment from "moment";
import {Options, setup, Vue,} from 'vue-class-component';
import {onMounted, provide, ref,} from 'vue'
import {useStore} from "vuex";
import * as echarts from 'echarts'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import routes from "@/routes/routes";

@Options({
  components: {
    LoadingMask,
    FileUploadProgress,
    // watermark,
  },

})
export default class App extends Vue {


  baseInfo = setup(() => {
    //在根组件中向子组件提供echarts
    provide('ec', echarts);
    const locale = zhCN;
    const system = ref("");
    const loadDeviceInfo = () => {
      let agent = navigator.userAgent.toLowerCase();
      system.value = (/macintosh|mac os x/i.test(navigator.userAgent)) ? "Mac" : "";
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        system.value = "windows";
      }
      if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        system.value = "windows";
      }
      document.getElementsByTagName('body')[0].className = system.value;
    }

    onMounted(() => {
      loadDeviceInfo();
    })
    return {locale, system};
  })


  storeInfo = setup(() => {
    const store = useStore();

    const loadStore = () => {
      let storeCache = sessionStorage.getItem('store');
      if (storeCache) {
        store.commit("setState", JSON.parse(storeCache));
        store.commit("reloadMask")
      }

      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(store.state))
      })
    }

    const initStore = () => {
      GlobalLoadingService.initStore(store);
      LoginService.initStore(store);
      store.commit('pageInit', routes)
    }


    onMounted(() => {
      loadStore();
      initStore();
    })
    return {}
  })

}
